import { useState, useEffect, useRef } from "react";
import * as axios from "axios";
import { ArticleExtraData } from "../../../../../../articlePage/stateInterfaces";
import { addAxiosDateTransformerSettings } from "../../../../../../utils/network/axiosDateTransformer";
import { ItemJsonVer2 } from "../../../../../jsonSerializer/widgetJsonInterfacesVer2";
import { mapItemJsonToArticleExtraData } from "../../../newsflashAndTwentyFourSeven/components/newsFlashSpecial/utils/newsFlashUtils";
import { NewsFlashSpecialDesktopPopup } from "../../../newsflashAndTwentyFourSeven/components/newsFlashSpecial/desktop/newsFlashSpecialDesktopPopup";
import { isWcmEditor } from "../../../../../../config/serverConfig";

require("./ynet_site_headerFlashBell.less");

const POLL_INTERVAL = 60000;
const BELL_ANIMATION_DURATION = 3000;
const POPUP_VISIBLE_ITEMS = 30;

export const HeaderFlashBell = () => {
    if (typeof window !== "undefined" && (window as any).disableFlashBell) {
        return null;
    }

    const [itemList, setItemList] = useState<ArticleExtraData[]>([]);
    const [isPopupOpen, setIsPopupOpen] = useState<boolean>(false);
    const [hasNewFlash, setHasNewFlash] = useState<boolean>(false);
    const [bellPhase, setBellPhase] = useState<"static" | "animated">("animated");
    const [highlightedArticleId, setHighlightedArticleId] = useState<string | null>(null);
    const previousFirstIdRef: any = useRef<string | null>(null);
    const bellTimerRef: any = useRef<ReturnType<typeof setTimeout> | null>(null);

    const getFlashItems = () => {
        const axiosInstance = axios.create(addAxiosDateTransformerSettings());

        axiosInstance.get("/iphone/json/mobile/v2/page/184")
            .then((res: any) => {
                const newArticles: ItemJsonVer2[] = res.data.components.find((component) => component.name === "flashesHeadlines").items;
                const converted = newArticles.map(article => mapItemJsonToArticleExtraData(article));

                const hasNewItem = previousFirstIdRef.current && converted.length > 0 && converted[0].articleId !== previousFirstIdRef.current;

                if (converted.length > 0) {
                    previousFirstIdRef.current = converted[0].articleId;
                }

                setItemList(converted);

                if (hasNewItem) {
                    triggerBellAnimation();
                    setHasNewFlash(!hasNewFlash);
                }
            })
            .catch(err => console.error("HeaderFlashBell: error getting flash data:", err));
    };

    const triggerBellAnimation = () => {
        if (bellTimerRef.current) {
            clearTimeout(bellTimerRef.current);
        }
        setBellPhase("animated");
        bellTimerRef.current = setTimeout(() => {
            setBellPhase("static");
        }, BELL_ANIMATION_DURATION);
    };

    useEffect(() => {
        getFlashItems();

        const intervalId = setInterval(() => {
            getFlashItems();
        }, POLL_INTERVAL);

        // Initial bell animation for 3 seconds
        bellTimerRef.current = setTimeout(() => {
            setBellPhase("static");
        }, BELL_ANIMATION_DURATION);

        return () => {
            clearInterval(intervalId);
            if (bellTimerRef.current) {
                clearTimeout(bellTimerRef.current);
            }
        };
    }, []);

    const handleOpenPopup = () => {
        if (isWcmEditor()) return;
        
        const scrollbarWidth = window.innerWidth - document.documentElement.clientWidth;
        document.body.style.paddingRight = `${scrollbarWidth}px`;
        document.body.style.overflow = "hidden";
        setHighlightedArticleId(null);
        setIsPopupOpen(true);
    };

    const handleClosePopup = () => {
        document.body.style.paddingRight = "";
        document.body.style.overflow = "";
        setIsPopupOpen(false);
    };

    return (
        <div className="header-flash-bell-wrapper">
            <div className="header-flash-bell" onClick={handleOpenPopup}>
                {bellPhase === "animated" ?
                    <video className="bell-animation-video" src="https://www.ynet.co.il/images/picsrv/Bell-Notification-30x30.webm" autoPlay muted playsInline />
                    :
                    <div className="bell-static-icon"></div>
                }
            </div>

            <NewsFlashSpecialDesktopPopup
                languageCode="he"
                isOpen={isPopupOpen}
                highlightingDuration={5}
                hasNewFlash={hasNewFlash}
                onClose={handleClosePopup}
                toAllFlashesLink={undefined}
                toAllFlashesLinkTarget={undefined}
                highlightedArticleId={highlightedArticleId}
                itemList={itemList.slice(0, POPUP_VISIBLE_ITEMS)}
            />
        </div>
    );
};
